'use client';

import React from 'react';
import { withRef } from '@udecode/cn';
import { Save } from 'lucide-react';
import { ToolbarButton } from './toolbar';

export const SaveToolbarButton = withRef<
  typeof ToolbarButton,
  {
    onSave: () => void;
    saving?: boolean;
    disabled?: boolean;
  }
>(({ onSave, saving = false, disabled = false, ...rest }, ref) => {
  return (
    <ToolbarButton
      ref={ref}
      tooltip="Save (Ctrl+S)"
      onClick={onSave}
      disabled={disabled || saving}
      {...rest}
    >
      <Save className="h-4 w-4" />
    </ToolbarButton>
  );
});
